<div class="card">
    <div class="card_body" #cardBody>
        <div class="comments" [style.height.px]="commentsListHeight" #commentsContainer>
            <app-comment [deletedComment] ='deletedComment' (deleteClick)="onDeleteClick($event)" (editClick)="onEditClick($event)" (changeNotes)="scrollToBottom($event)" [customerId]="customerId" [refreshTrigger]="refreshTrigger"></app-comment>
        </div>
        <div class="textarea_wrapper" #textareaWrapper>
            <app-text-area 
            (closeEvent)="onEditClose()"
            (actionEvent)="onTextAreaEvent($event)"
            (selectedEditTextCardHeight)="onCardHeightChange($event)" 
            [isEditing]="isEditing" [note]="selectedNote"
            (edit)="onCommentsEdit($event)"></app-text-area>
        </div>
    </div>
</div>
<app-confirm-modal *ngIf="(modalService.modalState$ | async) == 'clearNote'" (clear)="deleteNote()" title="Удалить комментарий?" text="После удаления комментарий нельзя будет восстановить." buttonText="Удалить"></app-confirm-modal>